import React from "react";
import { Link } from "react-router-dom";
import { TableCell, TableRow, Button } from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import ReplyIcon from "@material-ui/icons/Reply";
import { DeleteIcon } from "../../UI/Svgs";

import classes from "./ProjectsRow.module.scss";

export const ProjectsRow = ({ row, index, onEdit, onImport, onDelete }) => {
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit(row.id);
  };

  const handleImport = (e) => {
    e.preventDefault();
    onImport(row.id);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    onDelete(row.id);
  };

  return (
    <>
      <TableRow
        className={classes.projectsRow}
        component={Link}
        to={`/projects/${row.id}`}
        key={row.id}
      >
        <TableCell className={classes.gray} width={120}>
          {index + 1}
        </TableCell>
        <TableCell width={400}>
          <div className={classes.nameInner}>
            <span className={classes.name}>{row.name}</span>
          </div>
        </TableCell>
        <TableCell className={classes.gray} width={180}>
          {row.bitrix_group_id || "-"}
        </TableCell>
        <TableCell className={classes.gray} width={300}>
          {new Date(row.start).toLocaleDateString("ru-RU")}
        </TableCell>
        <TableCell width={160}>
          <div className={classes.actions}>
            <Button
              onClick={handleImport}
              classes={{
                root: `${classes.btn} ${classes.import_btn}`
              }}
            >
              <ReplyIcon />
            </Button>
            <Button
              onClick={handleEdit}
              classes={{
                root: classes.btn
              }}
            >
              <CreateIcon />
            </Button>
            <Button
              onClick={handleDelete}
              classes={{
                root: classes.btn
              }}
            >
              <DeleteIcon />
            </Button>
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};
